/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * File type that is not allowed to be uploaded in the Create Project application
 */
export enum ForbiddenFileType {
    EXE = 'EXE',
    JAR = 'JAR',
}
